import React, { ReactNode } from "react"

import { App } from "@sr/gatsby-theme-ui"

import lang from "../lang/index"

export interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  return <App lang={lang}>{children}</App>
}

export default Layout
